module.exports = {
	"root": "findify-components-common--grid",
	"column": "findify-components-common--grid__column",
	"column-1": "findify-components-common--grid__column-1",
	"column1": "findify-components-common--grid__column-1",
	"column-2": "findify-components-common--grid__column-2",
	"column2": "findify-components-common--grid__column-2",
	"column-3": "findify-components-common--grid__column-3",
	"column3": "findify-components-common--grid__column-3",
	"column-4": "findify-components-common--grid__column-4",
	"column4": "findify-components-common--grid__column-4",
	"column-5": "findify-components-common--grid__column-5",
	"column5": "findify-components-common--grid__column-5",
	"column-6": "findify-components-common--grid__column-6",
	"column6": "findify-components-common--grid__column-6",
	"column-7": "findify-components-common--grid__column-7",
	"column7": "findify-components-common--grid__column-7",
	"column-8": "findify-components-common--grid__column-8",
	"column8": "findify-components-common--grid__column-8",
	"column-9": "findify-components-common--grid__column-9",
	"column9": "findify-components-common--grid__column-9",
	"column-10": "findify-components-common--grid__column-10",
	"column10": "findify-components-common--grid__column-10",
	"column-11": "findify-components-common--grid__column-11",
	"column11": "findify-components-common--grid__column-11",
	"column-12": "findify-components-common--grid__column-12",
	"column12": "findify-components-common--grid__column-12"
};